import axios from 'axios';
import {retryInstance} from './retryInstance';

const defaultOptions: {
    baseURL: string | undefined;
    timeout: number;
} = {
    baseURL: process.env.REACT_APP_URL as string | undefined,
    timeout: 10000,
};

let activeToken: string | null = null;
// * Create the instance once: it carries the retry and 401 handling, so it
// * must survive logout/login rather than being recreated.
const instance = axios.create(defaultOptions);

instance.interceptors.request.use(
    (config: any) => {
        config.headers['Authorization'] = activeToken
            ? `Token ${activeToken}`
            : '';

        return config;
    },
    (error: any) => {
        console.log({AxiosInstance: error});
        return Promise.reject(error);
    },
);

export const updateToken: (token: string) => boolean = (token: string) => {
    activeToken = token;
    return true;
};

export const getActiveToken: () => string | null = () => {
    return activeToken;
};

export const getApiURL: () => string | undefined = () => {
    return defaultOptions.baseURL;
};

export const clearToken: () => void = () => {
    activeToken = null;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default () => instance;
retryInstance(instance);
